<template>
    <p-modal v-if="display" max-width="100%">
        <div slot="content">
            <p-note v-model="note" focus="true" min-height="200px"/>
            <div class="buttons">
                <div class="button cancel" @click="onCancel">取消</div>
                <div class="button save" @click="onConfirm">
                    <img src="@/assets/img/tick-white.svg">
                    儲存
                </div>
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';
    import Note from "../../shop/Note";

    export default {
        name: 'ShopNoteModel',
        components: {
            'p-modal': Modal,
            'p-note': Note,
        },
        data() {
            return {
                display: false,
                note: '',
            };
        },
        methods: {
            onConfirm() {
                this.$emit('onConfirm', this.note);
                this.display = false;
            },
            onCancel() {
                this.display = false;
                this.$emit('onCancel');
            },
            show(note) {
                this.note = note;
                this.display = true;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .content {
        .title {
            display: flex;
            justify-content: left;
            align-items: center;
            color: #339933;

            img {
                margin-right: 5px;
            }
        }

        .body {
            margin-top: 10px;
            font-size: 14px;
        }

        .buttons {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: 15px;

            .button {
                padding: 5px 15px;
                border-radius: 15px;
                background-color: #FFFFFF;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.5);
                color: #9b9b9b;
                font-size: 14px;
                line-height: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 10px;
                user-select: none;
                cursor: pointer;

                &.save {
                    background-color: #339933;
                    color: white;
                }
            }
        }
    }
</style>
